
export enum Category {
  Financeiro = 'Financeiro',
  Trabalhista = 'Trabalhista',
  Simuladores = 'Simuladores',
  Tempo = 'Tempo e Datas',
  Saude = 'Saúde, Nutrição e Corpo',
  Planejamento = 'Planejamento Pessoal',
  Consumo = 'Consumo e Utilidades',
  Matematica = 'Matemática Básica',
  DevTools = 'Ferramentas Dev'
}

export interface Calculator {
  id: string;
  title: string;
  slug: string;
  description: string;
  category: Category;
  icon: string;
  isNew?: boolean;
  comingSoon?: boolean;
  isPopular?: boolean;
}
